
import React, { useContext, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import moment from 'moment';
import TablePagination from '@material-ui/core/TablePagination';
import { DigitoVerificador, Duracion } from 'App/Helpers/Genericos'
import RemoteTable from 'App/components/RemoteTable';
import _ from 'underscore';
import {EstadoTarea} from 'App/Helpers/Iconos'
import { TareasContext } from 'App/Tareas/store'
import axios from 'axios';

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: "auto"
    },
    noWrap: {
        whiteSpace: "nowrap"
    }
});

function Tareas(props) {

    const tareasContext = useContext(TareasContext);
    const [cargando,setCargando] = useState(false);

    const tipos = [
        {clave: "EnvioLibro.Enviar", nombre:"Enviar Libro"},
        {clave: "EnvioDTE.Enviar", nombre:"Enviar DTE"},
        {clave: "Folios.Obtener", nombre:"Obtener Folios"},
        {clave: "Folios.Reobtener", nombre:"Reobtener Folios"},
        {clave: "RevisaDocumentos.Enviar", nombre:"Enviar Respuesta Comercial"}, //legacy
        {clave: "EnvioRespuestaComercial.Enviar", nombre:"Enviar Respuesta Comercial"},
        {clave: "EnvioCesion.Enviar", nombre:"Enviar Cesión"},
    ]

    const columns = [
        { name: "ID", key: "id_tarea", options: { display: true } },
        { name: "Empresa", key: "rut", options: { customBodyRender: (value, tableMeta, updateValue) => { return value+"-"+DigitoVerificador(value) } } },
        { name: "Tipo", key: "tipo", options: { customBodyRender: (value, tableMeta, updateValue) => { return (_.find(tipos,{clave:value})||{}).nombre } } },
        { name: "Creacion", key: "fecha_creacion", options: { sortDirection: 'desc', customBodyRender: (value, tableMeta, updateValue) => { return moment(value).format("DD/MM/YYYY HH:mm") } } },
        { name: "Ultimo Cambio", key: "fecha_ultimo_cambio", options: { customBodyRender: (value, tableMeta, updateValue) => { return moment(value).format("DD/MM/YYYY HH:mm") } } },
        { name: "Duración", key: "fecha_ultimo_cambio", options: { customBodyRender: (value, tableMeta, updateValue) => { return <Duracion desde={tableMeta.rowData[3]} hasta = {(tableMeta.rowData[6]=='Error'||tableMeta.rowData[6]=='Finalizada')?value:null}/> } }},
        { name: "Estado", key: "estado", options: { customBodyRender: (value, tableMeta, updateValue) => { return EstadoTarea(value) } } },
        { name: "Usuario", key: "usuario" },
    ]

    function actualizaTabla(data){
        if(!cargando){
            setCargando(true)
            axios.post("/api/tarea/listado",data)
                .then(data => {tareasContext.dispatch({type:'setListaTareas',data});setCargando(false)}).catch(e => console.error(e))
        }
    }
    useEffect(()=>{
        return ()=>{
            tareasContext.dispatch({type:'setListaTareas',data:{}})
        }
    },[])
    useEffect(()=>{
        if(_.any(tareasContext.state.ultimoCambio,e=> e.estado == "Creada")){
            actualizaTabla()
        }
    },[tareasContext.state.ultimoCambio])

    return (
        <div>
            <RemoteTable sort={false} columns={columns} query={actualizaTabla} contenido={tareasContext.state.listaTareas} data={{}} title={"Tareas"} CustomFooter={CustomFooter}></RemoteTable>
        </div>
    );
}

Tareas.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Tareas);

function CustomFooter(count, page, rowsPerPage, changeRowsPerPage, changePage) {
    return <TablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="Filas por página"
        backIconButtonProps={{
            'aria-label': 'Página anterior',
        }}
        nextIconButtonProps={{
            'aria-label': 'Página siguiente',
        }}
        onChangePage={(evt, page) => { changePage(page) }}
        onChangeRowsPerPage={(evt) => { changeRowsPerPage(evt.target.value) }}
    />
}